import { useEffect, useMemo, useRef } from "react";
import { stepDependenciesQueryOptions } from "~/components/build/Show/lib/queries/step-dependencies";
import { Build, Step, StepDependencyContext } from "~/components/build/Show/lib/types";
import { useStepDependenciesStore } from "~/components/build/Show/lib/useStepDependenciesStore";

type UseStepDependenciesReturn = {
  dependencies: StepDependencyContext["dependencies"];
  missingDependencies: StepDependencyContext["missing_dependencies"];
};

export function useStepDependencies(
  stepUuid: Step["uuid"] | null | undefined,
): UseStepDependenciesReturn {
  if (!stepUuid) {
    return {
      dependencies: [],
      missingDependencies: [],
    };
  }

  const dependenciesByStep = useStepDependenciesStore((state) => state.dependenciesByStep);
  const { dependencies = [], missing_dependencies: missingDependencies = [] } =
    dependenciesByStep[stepUuid] || {};

  return {
    dependencies,
    missingDependencies,
  };
}
